import { call, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { checkEmailActions } from "../slices";

function* checkEmailWorker({ payload }) {
  const { email } = payload;
  yield put(checkEmailActions.pending({ target: email }));
  try {
    const response = yield call(authApi.checkEmail, { email });
    yield put(checkEmailActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(checkEmailActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { checkEmailWorker };
